import React, { Component } from "react";
import "./Home.css";
import {  ListGroup ,ListGroupItem ,ButtonGroup ,Button,Jumbotron,FormGroup,ControlLabel,FormControl,Table,Col,Form,Checkbox} from "react-bootstrap";
import { API } from "aws-amplify";

import AUTHMD from '../md/HomeAuthenticated.md'
import UNAUTHMD from '../md/HomeUnAuthenticated.md'
import LoaderButton from "../components/LoaderButton";
import ReactMarkdown from 'react-markdown/with-html'

import Moment from 'react-moment';
import moment from "moment"
function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}



export default class AdminUsers extends Component {
    constructor(props) {
      super(props);
      this.state = {
          myaltioms:[],
          myaltioms_fetching:true,
          markdown:"",
          branch_name:"",
          branch_id:"",
          branch_type:"normal",
          newUser:false,
          responce:"",
          isSuper:false,
          isLoading:true,
          sortmode:"name",
          sortmodereverse:true,
          data:[]
      };
    }

    async componentWillMount() {
      //const data = await this.getInfo();
      //console.log(data)
      //this.setState(data)
      //console.log(this.state)
      let data=await this.getAdmin({admin:true,type:"branch",cmd:"listbranches"})

      console.log(data)
      if("newUser" in data){
          //not an admin!

      }
      else{
        this.setState({isSuper:true})
        this.setState({data:data})
      }
          this.setState({isLoading:false})

    }

    getAdmin(data){
      let getdata = {
        'queryStringParameters': data
      }
      return API.get("AltiomData", "/welcome",getdata);
    }

    hightlightSort(d){

      if(d==this.state.sortmode){
        return "bolder"
      }
      return ""


    }

    hightlightName(d){
      if(d==this.state.branch_name){
        return "red"
      }
      return ""


    }

    data_sort=(a,b)=>{

      let sA=a[this.state.sortmode]
      let sB=b[this.state.sortmode]
      if(this.state.sortmode=="date"){
        sA=a.date.$date
        sB=b.date.$date
      }

      if(this.state.sortmode=="Username"){
        sA=a.Attributes[2].Value.toLowerCase()
        sB=b.Attributes[2].Value.toLowerCase()
      }


      if(sA<sB){
        if(this.state.sortmodereverse==true)
          return 1
        return -1
      }
      if(sA>sB){
        if(this.state.sortmodereverse==true)
          return -1
        return 1
      }
      return 0
    }

    changeSort=(key)=>{
      console.log(key)
      if(key==this.state.sortmode){
        console.log(this.state.sortmodereverse)
        this.setState({sortmodereverse:!this.state.sortmodereverse})
      }
      this.setState({sortmode:key})
    }

mode=(d)=>{

  if(d.temp==true){
    return "Temperature"
  }
  if(d.sms==true){
    return "SMS"
  }
  return "Normal"
}

generateUID=()=>{
  let id=guid()
  this.setState({branch_id:id})
}

namechange=(e)=>{

  this.setState({branch_name:e.target.value})
}

typechange=(e)=>{

  this.setState({branch_type:e.target.value})
}

newBranch=async ()=>{
  console.log("Create a new branch")
  if(this.state.branch_name.length==0){
    alert("Please provide a name")
    return
  }
  if(this.state.branch_id.length==0){
    alert("no branch id. generating.....")
    this.generateUID()
    return
  }

  let d={ "name":this.state.branch_name,
          "id":this.state.branch_id,
          "type":this.state.branch_type
  }

  let data=await this.getAdmin({admin:true,type:"branch",cmd:"addbranch",data:JSON.stringify(d)})
  this.setState({data:data})


  this.setState({branch_id:""})



}


    render() {
      return (
          <div className="Home">
          <Jumbotron>
            <h2><a href="/admin">Admin</a> > Branches </h2>


            {/* Need to make this pagnate and search as number of users increases */}
            <hr/>
            {this.state.isSuper==true ? (
              <div>
              <h3>Create new branch</h3>
              <Form horizontal>
              <FormGroup controlId="formHorizontalEmail">
                <Col componentClass={ControlLabel} sm={2}>
                  Branch Name
                </Col>
                <Col sm={10}>
                  <FormControl type="text" value={this.state.branch_name} onChange={(e)=>this.namechange(e)} placeholder="Branch Name" />
                </Col>


                <Col componentClass={ControlLabel} sm={2}>
                  Type
                </Col>
                <Col sm={10}>
                  <FormControl componentClass="select" value={this.state.branch_type} onChange={(e)=>this.typechange(e)} >
                    <option value="normal">Normal</option>
                    <option value="temp">Temperature</option>
                    <option value="sms">SMS</option>
                  </FormControl>
                </Col>


              </FormGroup>

              <FormGroup controlId="formHorizontalPassword">
                <Col componentClass={ControlLabel} sm={2}>
                  Branch ID
                </Col>
                <Col sm={10}>
                <Button onClick={()=>this.generateUID()} >Generate ID</Button>
                <FormControl type="text" value={this.state.branch_id} placeholder="Unique id" />
                </Col>
              </FormGroup>



              <FormGroup>
                <Col smOffset={2} sm={10}>
                  <Button onClick={()=>this.newBranch()}>Add</Button>
                </Col>
              </FormGroup>
            </Form>


              <h2>Existing branches</h2>
            <Table striped bordered condensed hover>
                <thead>
                  <tr>
                  <th className={this.hightlightSort("name")}>Name <i className="glyphicon glyphicon-sort pull-right" onClick={()=>this.changeSort('name')}></i></th>
                    <th>Type</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data.sort((a,b)=>this.data_sort(a,b,this.state.sortmode)).map((d,index)=><tr key={d.Username}>
                      <td className={this.hightlightName(d.name)} >{d.name}</td>
                      <td >{this.mode(d)}</td>
                      <td><Button href={"/admin/branch/"+d.userId}>Edit</Button></td>


                    </tr>)}


                </tbody>
            </Table></div>):(<div>
{this.state.isLoading==true ? (<p>Loading</p>):(<p>No Data for you</p>)}
              </div>
)}









            </Jumbotron>
          </div>
        );
    }
}

//{this.props.isAuthenticated ? <ReactMarkdown className="CenterText" source={this.state.md_auth}  escapeHtml={false} /> : <ReactMarkdown className="CenterText" source={this.state.md_unauth}  escapeHtml={false}/>}



// WEBPACK FOOTER //
// ./src/containers/AdminBranch.js